<template>
  <section class="c-login-content">
    <div class="card c-login-box">
      <h5 class="card-header bg-primary text-right text-white">{{ $t('register') }}</h5>
      <div class="card-body">
        <form @submit="check">
          <form-input :label="$t('companyName')" :placeholder="$t('companyNamePlaceholder')" :model="form" attribute="companyName" :errors="errors"></form-input>
          <form-input :label="$t('accountName')" :placeholder="$t('accountNamePlaceholder')" :model="form" attribute="accountName" :errors="errors"></form-input>
          <form-input :label="$t('yourName')" :placeholder="$t('yourNamePlaceholder')" :model="form" attribute="name" :errors="errors"></form-input>
          <form-input :label="$t('email')" :placeholder="$t('emailPlaceholder')" :model="form" attribute="email" :errors="errors"></form-input>
          <form-input :label="$t('phone')" :placeholder="$t('phonePlaceholder')" :model="form" attribute="phone" :errors="errors"></form-input>
          <form-input type="password" :label="$t('password')" :placeholder="$t('passwordPlaceholder')" :model="form" attribute="password" :errors="errors"></form-input>
          <form-checkbox :chk-label="$t('subscribeRegistration')" :model="form" attribute="subscribeRegistration"
                   :errors="formErrors"></form-checkbox>
          <button class="btn btn-primary btn-lg btn-block is-border-circle" type="submit">{{ $t('register') }}</button>
        </form>
        <div class="c-login-more">
          <p>
            {{ $t('whenRegisterIRead') }}
            <a class="text-blue" href="#">{{ $t('terms') }}</a>
            {{ $t('ofCallio') }}
          </p>
          <p>
            {{ $t('alreadyHaveAnAccount') }}
            <b><a href="#/login">{{ $t('login') }}</a></b>
          </p>
        </div>
      </div>
    </div>
    <lang></lang>
    <b-modal v-model="showActivation" :title="$t('registerActivation')" no-close-on-esc no-close-on-backdrop no-enforce-focus>
      <div class="alert alert-success">
        <span>{{ $t('registerActivationNotice', [form.email, form.phone]) }}</span>
      </div>
      <form @submit="register">
        <form-input :label="$t('activationCode')" :placeholder="$t('activationCodePlaceholder')" :model="form" attribute="code" :errors="errors"></form-input>
      </form>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary" :disabled="resendCountDown>0" @click="check">
          {{ $t('resend') }}
          <span v-if="resendCountDown">&nbsp;({{ resendCountDown }})</span>
        </button>
        <button class="btn btn-primary" @click="register" :disabled="loading">
          <b-spinner small v-if="loading"></b-spinner>
          {{ $t('finishRegistration') }}
        </button>
      </template>
    </b-modal>
  </section>
</template>

<script>
import Lang from "../../components/Lang";
import _ from "lodash";

export default {
  components: {Lang},
  data: function () {
    return {
      form: {},
      errors: {},
      loading: false,
      showActivation: false,
      resendCountDown: 0,
      countDownInterval: null
    }
  },
  methods: {
    check: function (evt) {
      evt.preventDefault();
      this.errors = {};
      this.loading = true;
      this.$service.post('/auth/register-check', this.form).then(response => {
        if (response.data) {
          this.showActivation = true;
          this.resendCountDown = 60;
          this.countDownInterval = setInterval(() => {
            if (this.resendCountDown) {
              this.resendCountDown--;
            } else {
              clearInterval(this.countDownInterval);
            }
          }, 1000)
        }
      }).catch(error => {
        if (error.response.status === 420) {
          this.$swal({
            title: this.$t('error'),
            html: error.response.message,
            icon: 'error',
          }).then(() => {
            this.showActivation = false;
          });
        } else {
          this.errors = error.response.data;
        }
      }).finally(() => {
        _.delay(() => {
          this.loading = false;
        }, 250);
      });
    },
    register: function (evt) {
      evt.preventDefault();
      this.errors = {};
      this.loading = true;
      this.$service.post('/auth/register', this.form).then(response => {
        return this.$store.dispatch('login', response.data);
      }).then(() => {
        this.$swal({
          title: this.$t('success'),
          html: this.$t('registrationWelcome'),
          icon: 'success',
        }).then(() => {
          location.href = '#/';
        });
      }).catch(error => {
        this.errors = error.response.data;
      }).finally(() => {
        _.delay(() => {
          this.loading = false;
        }, 250);
      });
    },
  }
};
</script>